// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { stripeBaseUrl } from '.'


type RemovePaymentMethodResponse = (SuccessResponse & {}) | FailedResponse

export class RemovePaymentMethodRequest extends Request {
    private constructor(token: string, init?: RequestInit) { super(`${stripeBaseUrl}/payment/${token}`, init) }
    static async init(token: string, init?: RequestInit) {
        // The generateHeaders method sets the Content-Type header to `application/json` by default.
        // That header isn't supported with DELETE requests and has to be removed.
        const headers = await generateHeaders("Clerk-Token", init?.headers)
        headers.delete('Content-Type')
        return new RemovePaymentMethodRequest(token, {
            ...init,
            method: 'DELETE',
            headers: headers,
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<RemovePaymentMethodResponse>(await response.json())
        console.info("Remove Payment Method Results:", data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}